import React from 'react'
import { Button, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, useDisclosure, Flex, Text, Menu, MenuButton, MenuList, MenuItem, MenuDivider } from '@chakra-ui/react'
import { GiHamburgerMenu } from 'react-icons/gi';
import NavItem from '../NavItem';
import { AiOutlinePlusCircle } from 'react-icons/ai'
import SubNavItem from '../SubNavItem';
import { HiOutlineDesktopComputer } from "react-icons/hi";
import { FaRegFileAlt, FaUsers } from "react-icons/fa";
import { FaArrowsDownToPeople } from "react-icons/fa6";
import { RiBankFill } from "react-icons/ri";
import { useAuth } from 'react-oidc-context';
import { FotoUsuario } from '../FotoUsuario';
import { Permission, criancaFunc } from "../../../helpers/Funcionalidades";
import { useAuthProvider } from '../../../Context/AuthProvider';

export default function DrawerSidebar(props) {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const { roleKeycloack } = useAuthProvider();
    const btnRef = React.useRef()
    const navSize = "large"
    const auth = useAuth();

    const handleLogout = () => {
        auth.signoutRedirect();
    };


    function mudarDePagina() {
        sessionStorage.clear();
        onClose();
    }

    const customCloseDrawer = () => {
        sessionStorage.clear();
        onClose();
    }

    return (
        <>
            <Button variant="link" color="white" as={GiHamburgerMenu} ref={btnRef} p={2} onClick={onOpen} />
            <Drawer
                isOpen={isOpen}
                placement="right"
                onClose={onClose}
                finalFocusRef={btnRef}
            >
                <DrawerOverlay />
                <DrawerContent backgroundColor="#006064">
                    <DrawerCloseButton color={'white'} size={'lg'} />
                    <DrawerHeader alignContent="center" mt={5}>
                        <Flex alignItems={'center'}>
                            <Menu>
                                <MenuButton
                                    as={Button}
                                    rounded={'full'}
                                    variant={'link'}
                                    cursor={'pointer'}
                                    minW={0}>
                                    <FotoUsuario mobile={true} />
                                    {/* <Avatar
                                        size={'md'}
                                        m={2}
                                        src={
                                            'https://images.unsplash.com/photo-1493666438817-866a91353ca9?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=b616b2c5b373a80ffc9636ba24f7a4a9'
                                        }
                                    /> */}
                                </MenuButton>
                                <Text
                                    variant={'solid'}
                                    color={'white'}
                                    size={'sm'}
                                    mr={4}>
                                    Fabiana Castro
                                </Text>
                                <MenuList>
                                    <MenuItem>Perfil</MenuItem>
                                    <MenuItem>Configurações</MenuItem>
                                    <MenuDivider />
                                    <MenuItem onClick={handleLogout}>Sair</MenuItem>
                                </MenuList>
                            </Menu>
                        </Flex>
                    </DrawerHeader>

                    <DrawerBody p="0">
                        <Flex
                            w={"100%"}
                            flexDir="column"
                            alignItems={navSize === "small" ? "center" : "flex-start"}
                        >

                            <Flex
                                flexDir={"column"}
                                onClick={customCloseDrawer}
                                w={"100%"}
                            >
                                <NavItem navSize={navSize} href="/" icon={HiOutlineDesktopComputer} title="Dashboard" active={props.categoria === "Dashboard"} />
                                <NavItem navSize={navSize} href="/servico-acolhimento" icon={RiBankFill} title="Serviços de Acolhimento" active={props.categoria === "Serviços de Acolhimento"} />
                                <NavItem navSize={navSize} href="/crianca" icon={FaUsers} title="Crianças e Adolescentes" active={props.categoria === "Crianças e Adolescentes"} />
                                <NavItem navSize={navSize} href="/visitas/lista" icon={FaArrowsDownToPeople} title="Agenda de Visitas" active={props.entidade === "Visitas"} />
                                <NavItem navSize={navSize} href="/" icon={FaRegFileAlt} title="Relatórios" active={props.categoria === "Relatórios"} />


                            </Flex>
                            <Permission
                                roleKeycloack={roleKeycloack}
                                func={criancaFunc.visualizarTudo}
                            >
                                <NavItem href={"#"} navSize={navSize} icon={AiOutlinePlusCircle} title="Cadastros" isOpen={props.categoria === "Cadastros"} >
                                    <Flex flexDir={"column"} onClick={mudarDePagina}>
                                        <SubNavItem navSize={navSize} href="/tipo-servico-acolhimento/lista" title="Tipo de Serviço de Acolhimento" active={props.entidade === "Tipo de Serviço de Acolhimento"} />
                                        <SubNavItem navSize={navSize} href="/situacao-juridica/lista" title="Situação Jurídica" active={props.entidade === "Situação Jurídica"} />
                                        <SubNavItem navSize={navSize} href="/motivo-situacao/lista" title="Motivo de Situação" active={props.entidade === "Motivo de Situação"} />
                                        <SubNavItem navSize={navSize} href="/doenca/lista" title="Doença" active={props.entidade === "Doenças"} />
                                    </Flex>

                                </NavItem>
                            </Permission>
                        </Flex>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    )
}
